import React, { memo } from 'react';
import { Chip } from '@johnlewispartnership/wtr-ingredients/ingredients/Chips';
import { TooltipWrapper } from '@johnlewispartnership/wtr-ingredients/ingredients/ProductPod/TooltipWrapper';
import { useExperiments } from 'components/Experiment/useExperiments';
import { SHOW_PRODUCT_TAGS } from 'constants/monetateExperiments';
import { mapDataToTags, ProductTagType } from 'components/ProductPod2/utils';
import { ProductTag } from 'constants/products';

import styles from './index.scss';

export type ProductTagsProps = {
  productTags?: ProductTag[];
};

const ProductTags = ({ productTags }: ProductTagsProps) => {
  const { getDecisionById } = useExperiments();

  if (!productTags?.length) {
    return null;
  }

  // TODO: EoS Team this will hide 'Allergen update' tags which is required for
  // legal reasons, so take care if/when re-run this experiment.
  const hideTags =
    getDecisionById(SHOW_PRODUCT_TAGS.experiment).variant === SHOW_PRODUCT_TAGS.variant.hideTags;

  if (hideTags) {
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const mappedTags = mapDataToTags({ productTags })!;

  return (
    <div data-testid="productTags" className={styles.productTags}>
      <div className={styles.tagsWrapper}>
        {mappedTags.map(tag => (
          <div data-testid={tag.name} key={tag.name}>
            <TooltipWrapper tooltip={tag.tooltip}>
              <Chip
                small
                productChip
                colour={tag.type || ProductTagType.GREY}
                leadingIcon={tag.icon || undefined}
                trailingIcon={tag.trailingIcon || undefined}
              >
                {tag.name}
              </Chip>
            </TooltipWrapper>
          </div>
        ))}
      </div>
    </div>
  );
};

ProductTags.displayName = 'ProductTags';

export default memo(ProductTags);
